<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-subpage-gray">
    <!-- Header -->
    <Header :isHeaderFixed="false" :subpageLogoColor="'black'" :isMenuBlack="false" :hasMenu="false"></Header>

    <v-slide-x-transition leave-absolute hide-on-leave>
      <!-- Register Form -->
      <div v-if="isShowForm" style="padding-top: 42%; padding-left: 16px; padding-right: 16px;">
        <profile-form
          @registerSuccess = "registerSuccess"
          :type="'create'"
        ></profile-form>
      </div>
        
      <!-- Show Success  -->
      <div 
        v-if="isSuccess" 
        class="d-flex align-center" 
        style="padding: 0 16px; position: relative; height: 100%; max-height: calc(100vh - 68px);"
      >

        <div class="text-center" style="width: 100%;">
          <v-avatar size="62" color="#898989">
            <v-icon dark x-large>
              mdi-check
            </v-icon>
          </v-avatar>
          <div style="font-size: 18px;" class="pt-6">ลงทะเบียนสำเร็จ</div>
        </div>
        <div 
          style="
            position: absolute;
            bottom: 0px;
            width: 100%;
            left: 0;
            padding: 0 16px;
            padding-bottom: 16px;"
        >
          <v-btn
            tile
            dark
            color="#000"
            @click="changePage('profile')"
            style="width: 100%; height: 48px; font-size: 18px;"
          >
            ตกลง
          </v-btn>
        </div>
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Header from "@/components/Header.vue";
import ProfileForm from "@/views/Member/ProfileForm.vue";

export default {
  data() {
    return {
      isShowForm: true,
      isSuccess: false,
    };
  },
  components: {
    Header,
    ProfileForm
  },  
  computed: {
    moment() {
      return moment;
    },
  },
  methods: {
    getMemberData() {
      var vm = this;
      return new Promise((resolve) => {
        var data = { 
          userid: vm.$store.state.userid, 
          pageid: vm.$route.query.pageid
        };

        axios
          .get(vm.serverUrl + "lamy/member", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.$store.state.member = response.data.data[0];
              vm.$store.state.member.totalPurchase = response.data.all_total_purchase;
              // vm.member =  vm.$store.state.member;

            } else if(response.data.responsecode == 204) {
              this.$router.push({
                path: 'home',
                query: {...this.$route.query } ,
              });
            } else {
              await vm.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
              vm.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    registerSuccess() {
      this.isShowForm = false;
      this.isSuccess = true;
      // this.getMemberData();
    },
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>